import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { updateRow } from './AlertsPrioritySlice';
import styles from './ReferenceCode.module.css';
import modalStyles from '../../components/ModalStyles.module.css';
import { useSelector, useDispatch } from 'react-redux';
import useAxios from '../../services/AxiosConfig';
import { showAlert } from '../../components/PerinHealthAlertSlice';

const EditAlertPriorityModal = ({ show, onHide }) => {
    const dispatch = useDispatch();
    const {rows, selectedRowId} = useSelector((state) => state.alertsPriority);
    const editData = rows.find((row) => row.AlertsPriority_id === selectedRowId);
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const axios = useAxios(axiosConfig.envURL);

    const [formData, setFormData] = useState({
        prioritySet: '',
        color: '',
        hoverDisplay: '',
        latchingStatus: false,
        taskFlag: false,
        bellNotificationFlag: false,
        pushNotificationFlag: false,
        displayName: '',
        description: '',
        sms: false,
    });

    useEffect(() => {
        if (editData) {
            setFormData({
                prioritySet: editData.AlertPriority_PrioritySet ?? '',
                color: editData.AlertPriority_Color ?? '',
                hoverDisplay: editData.AlertPriority_HoverDisplay ?? '',
                latchingStatus: editData.AlertPriority_LatchingStatus ?? false,
                taskFlag: editData.AlertPriority_TaskFlag ?? false,
                bellNotificationFlag: editData.AlertPriority_BellNotificationFlag ?? false,
                pushNotificationFlag: editData.AlertPriority_PushNotificationFlag ?? false,
                displayName: editData.AlertPriority_DisplayName_Business ?? '',
                description: editData.AlertPriority_Description_Business ?? '',
                sms: editData.AlertPriority_SMS ?? false,
            });
        }
    }, [editData]);

    const handleChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
    };

    if (!editData) return null;
    
    const colorOptions = [
        { value: 'yellow', label: 'Yellow' },
        { value: 'red', label: 'Red' },
        { value: 'green', label: 'Green' },
        { value: '', label: 'None' }
    ];

    const priorityOptions = [  
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
        { value: '', label: 'None' }
    ];

    const handleSave = async () => {
        const putBody = {
            AlertPriority_DisplayName_Business: formData.displayName,
            AlertPriority_PrioritySet: formData.prioritySet === '' ? undefined : formData.prioritySet,
            AlertPriority_Color: formData.color === '' ? undefined : formData.color,
            AlertPriority_HoverDisplay: formData.hoverDisplay,
            AlertPriority_Description_Business: formData.description,
            AlertPriority_BellNotificationFlag: formData.bellNotificationFlag,
            AlertPriority_PushNotificationFlag: formData.pushNotificationFlag,
            AlertPriority_TaskFlag: formData.taskFlag,
            AlertPriority_SMS: formData.sms,
            AlertPriority_LatchingStatus: formData.latchingStatus,
        };
        try {
            const response = await axios.request({
                method: 'PUT',
                headers: { "Content-Type": "application/json" },
                url: `alertsPriority/${selectedRowId}`,
                data: JSON.stringify(putBody),
            });
            if (response) {
                dispatch(showAlert({
                    header: "Success",
                    message: "Alert priority updated successfully",
                    type: "success",
                }));
            }
            onHide(true);
        } catch (error) {
            dispatch(showAlert({
                header: "Error",
                message: "Error updating alert priority",
                type: "danger",
            }));
        }
    };

    return (
        <Modal show={show} onHide={onHide} backdrop="static" size="lg" style={{ fontFamily: "Roboto" }}>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: "20px" }}>
                    Edit Alert Priority
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className="mb-3">
                        <Col>
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                disabled
                                className={styles.CodeInput}
                                value={editData.AlertPriority_NotificationName || ''}
                            />
                        </Col>
                        <Col>
                            <Form.Label>Type</Form.Label>
                            <Form.Control
                                disabled
                                className={styles.CodeInput}
                                value={editData.AlertPriority_Type || ''}
                            />
                        </Col>
                        <Col>
                            <Form.Label>Sub-Type</Form.Label>
                            <Form.Control
                                disabled
                                className={styles.CodeInput}
                                value={editData.AlertPriority_AlertSubType || ''}
                            />
                        </Col>
                       
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                className={styles.CodeInput}
                                required
                                value={formData.displayName}
                                onChange={(e) => handleChange('displayName', e.target.value)}
                            />
                        </Col>
                        <Col>
                            <Form.Label>Hover Display</Form.Label>
                            <Form.Control
                                className={styles.CodeInput}
                                required
                                value={formData.hoverDisplay}
                                onChange={(e) => handleChange('hoverDisplay', e.target.value)}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                className={styles.CodeInput}
                                required
                                value={formData.description}
                                onChange={(e) => handleChange('description', e.target.value)}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Label>Priority</Form.Label>
                            <Form.Select
                                className={styles.CodeInput}
                                required
                                value={formData.prioritySet}
                                onChange={(e) => handleChange('prioritySet', e.target.value)}
                            >
                                 {priorityOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Label>Color</Form.Label>
                            <Form.Select
                                className={styles.CodeInput}
                                required
                                value={formData.color}
                                onChange={(e) => handleChange('color', e.target.value)}
                            >
                                {colorOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        
                    </Row>
                    <Row className="mb-3">
                        <Col xs={4} >
                            <Form.Group>
                                <Form.Check
                                    type="switch"
                                    id="bell-notification"
                                    label="Bell Notification"
                                    checked={formData.bellNotificationFlag}
                                    onChange={(e) => handleChange('bellNotificationFlag', e.target.checked)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={4} >
                            <Form.Group>
                                <Form.Check
                                    type="switch"
                                    id="push-notification"
                                    label="Push Notification"
                                    checked={formData.pushNotificationFlag}
                                    onChange={(e) => handleChange('pushNotificationFlag', e.target.checked)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={4} >
                            <Form.Group>
                                <Form.Check
                                    type="switch"
                                    id="sms"
                                    label="SMS"
                                    checked={formData.sms}
                                    onChange={(e) => handleChange('sms', e.target.checked)}
                                />
                            </Form.Group>
                        </Col>
                        
                    </Row>
                    <Row className="mb-3">
                        <Col xs={4}>
                            <Form.Group>
                                <Form.Check
                                    type="switch"
                                    id="latchingStatus"
                                    label="Latching"
                                    checked={formData.latchingStatus}
                                    onChange={(e) => handleChange('latchingStatus', e.target.checked)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={4}>
                            <Form.Group>
                                <Form.Check
                                    type="switch"
                                    id="task"
                                    label="Task"
                                    checked={formData.taskFlag}
                                    onChange={(e) => handleChange('taskFlag', e.target.checked)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    variant="secondary" 
                    className={modalStyles.SecondaryButton}
                    onClick={onHide}
                >
                    Cancel
                </Button>
                <Button 
                    variant="primary" 
                    className={modalStyles.PrimaryButton}
                    onClick={handleSave}
                >
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditAlertPriorityModal;

